import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import HighLightProxy from './proxy'

class HighLightService extends ServiceBase {
  getHighLight(params) {
    return this.getData(() => HighLightProxy.getHighLight(params))
  }
}

export default new HighLightService()
